module.exports = __webpack_public_path__ + "static/media/addHazard.8895730c.png";